import { PreferenceKeys } from '@app/models/enums'
import { ApplicationState } from '@app/store'
import {
  ICurrentUserState,
  selectCurrentUser,
  selectPreference,
} from '@app/store/modules/account'
import { connect } from 'react-redux'
import { withRouter } from 'react-router-dom'
import { createStructuredSelector } from 'reselect'
import { ILandingPageProps, LandingPage } from '../components/LandingPage'

export default withRouter(
  connect(
    createStructuredSelector<
      ApplicationState,
      ILandingPageProps & ICurrentUserState
    >({
      landingPage: selectPreference(PreferenceKeys.LandingPage),
      lastPage: selectPreference(PreferenceKeys.LastPage),
      user: selectCurrentUser(),
    }),
  )(LandingPage),
)
